import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { OtLozenge, OtIcon, OtNumberDisplay } from '@1trading/design-system';
import type { PropType } from 'vue';
import { computed, toRefs } from 'vue';
import { useI18n } from 'vue-i18n';

import type { NormalizedPerpsPosition } from '@exchange/libs/account/service/src/lib/wss-account-messages';

import DivTableCell from '../components/DivTableCell.vue';
import DivTableRow from '../components/DivTableRow.vue';
import usePositionComputed from '../usePositionComputed';


export default /*#__PURE__*/_defineComponent({
  __name: 'OpenPositionsItem',
  props: {
  position: {
    type: Object as PropType<NormalizedPerpsPosition>,
    required: true,
  },
  maxLeverage: {
    type: Number,
    required: false,
  },
},
  emits: ['close-position'],
  setup(__props, { emit: __emit }) {

const { t } = useI18n({ useScope: 'global' });

const props = __props;

const emit = __emit;

const { position, maxLeverage } = toRefs(props);
const { marginUsed, market, unrealizedPnL } = usePositionComputed(position, maxLeverage);

const directionText = computed(() => (props.position.direction === 'LONG' ? t('fundamentals.orders.side.long') : t('fundamentals.orders.side.short')));
const directionClass = computed(() => (props.position.direction === 'LONG' ? 'direction-long' : 'direction-short'));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DivTableRow, {
    class: "positions-item",
    "data-id": _unref(position).instrument_code
  }, {
    default: _withCtx(() => [
      _createVNode(DivTableCell, { class: "positions-item__cell" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(market)?.name) + " ", 1),
          _createVNode(_unref(OtLozenge), {
            filled: false,
            text: _ctx.$t('fundamentals.perpetual.short'),
            class: "lozenge"
          }, null, 8, ["text"])
        ]),
        _: 1
      }),
      _createVNode(DivTableCell, { class: "positions-item__cell" }, {
        default: _withCtx(() => [
          _createElementVNode("span", {
            class: _normalizeClass(directionClass.value)
          }, _toDisplayString(directionText.value), 3)
        ]),
        _: 1
      }),
      _createVNode(DivTableCell, { class: "positions-item__cell" }, {
        default: _withCtx(() => [
          _createVNode(_unref(OtNumberDisplay), {
            number: _unref(position).open_volume,
            precision: _unref(market)?.amountPrecision,
            suffix: _unref(market)?.base.code
          }, null, 8, ["number", "precision", "suffix"])
        ]),
        _: 1
      }),
      _createVNode(DivTableCell, { class: "positions-item__cell" }, {
        default: _withCtx(() => [
          _createVNode(_unref(OtNumberDisplay), {
            number: _unref(position).open_position,
            precision: _unref(market)?.marketPrecision,
            suffix: _unref(market)?.quote.code
          }, null, 8, ["number", "precision", "suffix"])
        ]),
        _: 1
      }),
      _createVNode(DivTableCell, { class: "positions-item__cell" }, {
        default: _withCtx(() => [
          _createVNode(_unref(OtNumberDisplay), {
            number: _unref(position).average_entry_price,
            precision: _unref(market)?.marketPrecision,
            suffix: _unref(market)?.quote.code
          }, null, 8, ["number", "precision", "suffix"])
        ]),
        _: 1
      }),
      _createVNode(DivTableCell, { class: "positions-item__cell" }, {
        default: _withCtx(() => [
          _createVNode(_unref(OtNumberDisplay), {
            number: _unref(position).mark_price,
            precision: _unref(market)?.marketPrecision,
            suffix: _unref(market)?.quote.code
          }, null, 8, ["number", "precision", "suffix"])
        ]),
        _: 1
      }),
      _createVNode(DivTableCell, { class: "positions-item__cell" }, {
        default: _withCtx(() => [
          _createVNode(_unref(OtNumberDisplay), {
            number: _unref(position).last_settlement,
            precision: _unref(market)?.marketPrecision,
            suffix: _unref(market)?.quote.code,
            class: _normalizeClass({ 'profit-positive': Number(_unref(position).last_settlement) > 0, 'profit-negative': Number(_unref(position).last_settlement) < 0 })
          }, null, 8, ["number", "precision", "suffix", "class"])
        ]),
        _: 1
      }),
      _createVNode(DivTableCell, { class: "positions-item__cell" }, {
        default: _withCtx(() => [
          _createVNode(_unref(OtNumberDisplay), {
            number: _unref(position).realised_pnl,
            precision: _unref(market)?.marketPrecision,
            suffix: _unref(market)?.quote.code,
            class: _normalizeClass({ 'profit-positive': Number(_unref(position).realised_pnl) > 0, 'profit-negative': Number(_unref(position).realised_pnl) < 0 })
          }, null, 8, ["number", "precision", "suffix", "class"])
        ]),
        _: 1
      }),
      _createVNode(DivTableCell, { class: "positions-item__cell" }, {
        default: _withCtx(() => [
          _createVNode(_unref(OtNumberDisplay), {
            number: _unref(unrealizedPnL),
            precision: _unref(market)?.marketPrecision,
            suffix: _unref(market)?.quote.code,
            class: _normalizeClass({
          'profit-positive': _unref(unrealizedPnL) > 0,
          'profit-negative': _unref(unrealizedPnL) < 0,
        })
          }, null, 8, ["number", "precision", "suffix", "class"])
        ]),
        _: 1
      }),
      _createVNode(DivTableCell, { class: "positions-item__cell" }, {
        default: _withCtx(() => [
          _createVNode(_unref(OtNumberDisplay), {
            number: _unref(marginUsed),
            precision: _unref(market)?.marketPrecision,
            suffix: _unref(market)?.quote.code
          }, null, 8, ["number", "precision", "suffix"])
        ]),
        _: 1
      }),
      _createVNode(DivTableCell, { class: "positions-item__cell" }, {
        default: _withCtx(() => [
          _createElementVNode("button", {
            class: "position-close-button",
            name: "close-position-button",
            onClick: _cache[0] || (_cache[0] = () => emit('close-position', _unref(position)))
          }, [
            _createVNode(_unref(OtIcon), { name: "close-square" })
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["data-id"]))
}
}

})